<template>
  <div>
    <div class="container-fluid">
      <vx-card title="Traspaso y Compra Venta en Mercado Secundario" subtitle-color="dark"
        subtitle="Ingresa el id del inversionista que quiere vender o traspasar sus inversiones y obten su información para continuar."
        class="mt-3">
        <div class="vx-row">
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <vs-select placeholder="Seleccione" label="Tipo de movimiento" class="w-full" v-model="operationType">
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in operationTypeOptions" />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>ID Inversionista. <small>({{ sellerText }})</small></label>
            <vx-input-group>
              <vs-input type="number" class="w-full" icon-pack="feather" icon="icon-user" v-model="sellerInvestorId" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="dark" @click="getSellerParticipation()"
                    :disabled="!sellerInvestorId">Buscar</vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>ID Inversionista. <small>({{ buyerText }})</small></label>
            <vs-input type="number" class="w-full" icon-pack="feather" :disabled="!searchComplete" icon="icon-user"
              v-model="buyerInvestorId" />
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>Monto</label>
            <vs-input class="w-full" type="text" v-model.lazy="fixedInvestmentMoneyToMove" v-money="money"
              name="fixedInvestmentMoneyToMove" icon-pack="feather" icon="icon-dollar-sign" autocomplete="off"
              :placeholder="'Monto a ' + sellerText" />
          </div>
          <div v-if="operationType == 1" class="vx-col md:w-1/6 w-full mb-2">
            <label class="mt-5">Cobrar comisión</label>
            <vs-switch color="success" v-model="chargeCommission"></vs-switch>
          </div>
          <div v-if="operationType == 1" class="vx-col md:w-1/6 w-full mb-2">
            <label class="mt-5">Generar retiro</label>
            <vs-switch color="success" v-model="makeWithdrawal"></vs-switch>
          </div>
          <!-- <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>% de Participación</label>
            <vs-input type="number" class="w-full" icon-pack="feather" icon="icon-percent" v-model="sharePercentage" />
          </div> -->
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <div class="flex justify-start flex-wrap">
              <!-- <vs-button class="mt-6 mr-5" color="dark" @click="setAllFixedInvestmentAmount()">{{ operationTypeText }} Todo</vs-button> -->
              <vs-button class="mt-6" color="success" :disabled="!searchComplete ||
                !buyerInvestorId ||
                sellerInvestorId == rgInvestorId
                " @click="confirmTransaction()">Confirmar</vs-button>
            </div>
          </div>
        </div>

        <div class="vx-row mt-3" v-if="searchComplete">
          <div class="vx-col md:w-1/2 w-full mt-5">
            <h3 class="bold">
              Datos de quién {{ sellerText }} (IID: {{ sellerInvestorId }})
            </h3>
            <h5>
              Inversión efectiva: <b>{{ this.explicitMoneyFormat(sellerInvestorInfoData.amount) }}</b>
            </h5>
            <h5>
              % de Participación: <b>{{ this.decimalPercentFormat(sellerInvestorInfoData.share) }}</b>
            </h5>
            <h5>
              Saldo disponible: <b>{{ this.explicitMoneyFormat(sellerInvestorInfoData.final_balance) }}</b>
            </h5>
          </div>
          <!-- <div v-if="isBuyerValid" class="vx-col md:w-1/2 w-full mt-5">
            <h3 class="bold">
              Datos de quién {{ buyerText }} (IID: {{ buyerInvestorId }})
            </h3>
            <h5>
              Inversión efectiva: <b>{{ this.explicitMoneyFormat(buyerInvestorInfoData.amount) }}</b>
            </h5>
            <h5>
              % de Participación: <b>{{ this.decimalPercentFormat(buyerInvestorInfoData.share) }}</b>
            </h5>
            <h5>
              Saldo disponible: <b>{{ this.explicitMoneyFormat(buyerInvestorInfoData.final_balance) }}</b>
            </h5>
          </div> -->
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import { VMoney } from 'v-money'
import currencyHelper from "@mixins/currencyHelper";

export default {
  name: 'secondary-market-trading',
  props: [],
  mixins: [formatHelper, currencyHelper],
  directives: { money: VMoney },
  data() {
    return {
      fixedInvestmentMoneyToMove: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      operationTypeText: "Traspasar",
      sellerText: "traspasa",
      buyerText: "recibe",
      rgInvestorId: 1190,
      sellerInvestorId: null,
      buyerInvestorId: null,
      // sharePercentage: 0,
      searchComplete: false,
      operationTypeOptions: [
        { text: 'Traspaso', value: 0 },
        { text: 'Compra-venta', value: 1 }
      ],
      operationType: 0,
      currentSellerInvestorId: null,
      buyerInvestorInfoData: {
        registered_on_sm: false,
        share: null,
        amount: 0,
        final_balance: 0
      },
      sellerInvestorInfoData: {
        registered_on_sm: false,
        share: null,
        amount: 0,
        final_balance: 0
      },
      chargeCommission: true,
      makeWithdrawal: true,
    }
  },
  computed: {
    isMobileScreen() {
      return this.$store.state.windowWidth <= this.mobileScreen
    },
    isBuyerValid() {
      return (this.buyerInvestorInfoData === "" || !this.buyerInvestorInfoData.registered_on_sm) ? false : true;
    }
  },
  watch: {
    sellerInvestorId: function (val) {
      if (val != this.currentSellerInvestorId) {
        this.searchComplete = false;
      } else {
        this.searchComplete = true;
      }
    },
    operationType: function (val) {
      if (val == 0) {
        this.sellerText = "traspasa";
        this.buyerText = "recibe";
        this.operationTypeText = "Traspasar";
        this.chargeCommission = false;
        this.makeWithdrawal = false;
      } else {
        this.sellerText = "vende";
        this.buyerText = "compra";
        this.operationTypeText = "Vender"
        this.chargeCommission = true;
        this.makeWithdrawal = true;
      }
    }
  },
  methods: {
    async getSellerParticipation() {
      this.sellerShare = 0;
      this.sellerAmountParticipation = 0;
      this.showLoading(true);
      try {
        const res = await axios.post(`api/inversionista/${this.sellerInvestorId}/secondary-market-participation`, {});
        this.sellerInvestorInfoData = res.data;
        this.searchComplete = true;
        this.currentSellerInvestorId = this.sellerInvestorId;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    // setAllFixedInvestmentAmount() {
    //   this.fixedInvestmentMoneyToMove = 0;
    //   this.$forceUpdate();
    // },
    async confirmTransaction() {
      let fixedInvestmentAmount = this.unMoneyFormat(this.fixedInvestmentMoneyToMove);
      if (fixedInvestmentAmount <= 0) {
        this.errorNotif("Aviso", "El monto debe ser mayor a 0", 4000);
        return;
      }

      if (fixedInvestmentAmount > this.sellerInvestorInfoData.amount) {
        this.errorNotif("Aviso", "El monto no debe ser mayor a la inversión efectiva", 4000);
        return;
      }

      if (this.currentSellerInvestorId == this.buyerInvestorId) {
        this.errorNotif("Aviso", "El inversionista que compra no puede ser el mismo que vende, verifique sus datos", 4000);
        return;
      }

      await this.getBuyerInvestorInfo();
      if (!this.isBuyerValid) {
        this.errorNotif("Aviso", "El inversionista no pertenece al mercado, verifique sus datos", 4000);
        return;
      }

      if (this.operationType == 1 && this.buyerInvestorInfoData.final_balance < fixedInvestmentAmount) {
        this.errorNotif("Aviso", "El comprador no cuenta con saldo suficiente, su saldo actual es de: " + this.explicitMoneyFormat(this.buyerInvestorInfoData.final_balance), 7000);
        return;
      }

      let title = "¿Continuar con el traspaso?";
      let message = `Se traspasará una inversión fija de ${this.explicitMoneyFormat(fixedInvestmentAmount)}, del IID: ${this.currentSellerInvestorId} al IID: ${this.buyerInvestorId}`;
      if (this.operationType == 1) {
        title = "¿Continuar con la venta?";
        message = `Se realizará la venta de una inversión fija de ${this.explicitMoneyFormat(fixedInvestmentAmount)}, del IID: ${this.currentSellerInvestorId} al IID: ${this.buyerInvestorId}`;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: title,
        text: message,
        acceptText: "Confirmar",
        cancelText: "Cancelar",
        accept: this.executeTransaction
      })
    },
    async getBuyerInvestorInfo() {
      this.buyerInvestorInfoData = "";
      this.showLoading(true);
      try {
        const res = await axios.post(`api/inversionista/${this.buyerInvestorId}/secondary-market-participation`, {});
        this.buyerInvestorInfoData = res.data;
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    },
    async executeTransaction() {
      this.showLoading(true);
      try {
        let fixedInvestmentAmount = this.unMoneyFormat(this.fixedInvestmentMoneyToMove);
        const res = await axios.post(`api/backoffice/investor/create-market-selling-order`, {
          operation_type: this.operationType,
          amount: fixedInvestmentAmount,
          seller_investor_id: this.currentSellerInvestorId,
          buyer_investor_id: this.buyerInvestorId,
          charge_commission: this.chargeCommission,
          make_withdrawal: this.makeWithdrawal
        });
        this.successNotif("Aviso", res.data.message, 4000);
        await this.getSellerParticipation();
      } catch (e) {
        if (e.response != undefined && e.response.data != undefined && e.response.data.message != undefined) {
          this.errorNotif("Aviso", e.response.data.message, 4000);
        } else {
          console.log(e);
          this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
        }
      }
      this.showLoading(false);
    }
  }
}
</script>

<style>
.con-vs-dialog {
  z-index: 100000 !important;
}
</style>
